import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { isEmbedded } from "@app/shared/resources/embedded-mobile-checker";
import { Subject } from "rxjs";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";

@Component({
    selector: "clare-select",
    templateUrl: "./clare-select.component.html",
    styleUrls: ["./clare-select.component.scss"],
})
export class ClareSelectComponent implements OnInit, OnDestroy {
    @Input() metaData: any;
    @Input() theForm: FormGroup;
    @Input() isLoading: boolean;
    @Input() enableRetry: boolean;
    @Output() getValueEmitter = new EventEmitter<void>();
    formControl;
    selectOptions = [];
    selectLabel;
    @Input() showLabel = true;

    private unsubscribe$ = new Subject<void>();

    get isEmbedded() {
        return isEmbedded();
    }

    ngOnInit() {
        const selectedOptions = [];
        Object.keys(this.metaData.enum).forEach(objectKey => {
            if (this.metaData.enum[objectKey] !== null) {
                selectedOptions.push({ key: objectKey, value: this.metaData.enum[objectKey] });
            } else {
                this.selectLabel = {
                    labelKey: objectKey,
                    labelValue: this.metaData.enum[objectKey],
                };
            }
        });

        this.convertValue(selectedOptions?.[0].value);
        this.selectOptions = [...selectedOptions].sort((a, b) => a?.value - b?.value);

        this.formControl = this.theForm.controls[this.metaData.inputName];
        this.formControl.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe(value => {
            if (value === null) {
                this.formControl.disable({ emitEvent: false });
            } else {
                this.formControl.enable({ emitEvent: false });
            }
        });
    }

    convertValue(enumValue) {
        // Sometimes the device metadata accepts a different value type than it responds with.
        // In this case, we must make the types match.
        // Example -- reportCode on a sensor has an enum of strings but returns a numeric value.
        if (typeof enumValue !== typeof this.theForm.controls[this.metaData.inputName].value) {
            let value = this.theForm.controls[this.metaData.inputName].value;

            if (typeof enumValue === "string") {
                value = this.theForm.controls[this.metaData.inputName].value + "";
            } else if (typeof enumValue === "number") {
                value = parseInt(this.theForm.controls[this.metaData.inputName].value, 10);
            }

            this.theForm.controls[this.metaData.inputName].setValue(value, { emitEvent: false });
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
